<mat-dialog-content>
  <table style="width:100%">
    @for (ct of deployment.ControllerTypes; track ct; let i = $index) {
      <tr>
        <td>{{ct.Description}}</td>
        <td><mat-checkbox class="checkbox-text" (change)="onErrorCodesChange($event, i)">ErrorCodes?</mat-checkbox></td>
        <td><mat-checkbox class="checkbox-text" (change)="onOpModesChange($event, i)">OpModes?</mat-checkbox></td>
      </tr>
    }
  </table>
</mat-dialog-content>
